import { ActionContext, ActionType, ITwoStateAction } from "UI/UI.Controls/Actions/IAction";
import { IFrame } from "../IFrame";
import { StandardAction } from "./StandardAction";

export class StandardTwoStateAction extends StandardAction implements ITwoStateAction {
    //#region Fields
    private _checked: boolean;
    //#endregion Fields

    //#region Properties
    public get checked(): boolean {
        return this._checked;
    }

    public set checked(value: boolean) {
        this._checked = value;
    }
    //#endregion Properties

    //#region Constructors
    constructor(actionType: ActionType, action: () => Promise<void>, lockey: string, context: ActionContext = ActionContext.objectAction, priority: number = 1,
        owner?: IFrame, currentState: boolean = false) {
        super(actionType, action, lockey, context, priority, owner);
        this._checked = currentState;
    }
    //#endregion Constructors

    //#region Methods
    //#endregion Methods
}
